<script setup lang="ts">
const props = defineProps<{
  tripIdList: string[]
}>()
</script>
<template>
  <template v-for="(tripId, index) in props.tripIdList" :key="index">
    <div class="trip-item">{{ tripId }}</div>
  </template>
</template>
